/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InspectionArchiveImagesMergeDto } from './inspectionArchiveImagesMergeDto';
import { InspectionEntryMergeDto } from './inspectionEntryMergeDto';
import { AttachmentReferenceDto } from './attachmentReferenceDto';
import { BuildingSectionImagesMergeDto } from './buildingSectionImagesMergeDto';
import { IdReferenceDto } from './idReferenceDto';


export interface InspectionMergeDto { 
    id?: string;
    name?: string;
    description?: string;
    buildingId?: string;
    technicianReference?: IdReferenceDto;
    clerkReference?: IdReferenceDto;
    version?: number;
    fromTimestamp?: string;
    toTimestamp?: string;
    sendingTimestamp?: string;
    continuationNumber?: number;
    normType?: InspectionMergeDto.NormTypeEnum;
    inspectionType?: InspectionMergeDto.InspectionTypeEnum;
    status?: InspectionMergeDto.StatusEnum;
    archiveImages?: Array<InspectionArchiveImagesMergeDto>;
    inspectionEntries?: Array<InspectionEntryMergeDto>;
    coverImageReference?: AttachmentReferenceDto;
    locationReplacement?: AttachmentReferenceDto;
    lastSavedTimeStamp?: string;
    usedTemplateId?: string;
    buildingSectionImages?: Array<BuildingSectionImagesMergeDto>;
    applyPreviousInspection?: string;
}
export namespace InspectionMergeDto {
    export type NormTypeEnum = 'NORM_1300' | 'NORM_1301';
    export const NormTypeEnum = {
        Norm1300: 'NORM_1300' as NormTypeEnum,
        Norm1301: 'NORM_1301' as NormTypeEnum
    };
    export type InspectionTypeEnum = 'REGULAR' | 'SCHADSTELLENPLAN';
    export const InspectionTypeEnum = {
        Regular: 'REGULAR' as InspectionTypeEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as InspectionTypeEnum
    };
    export type StatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'IN_REVIEW' | 'DONE' | 'SENT' | 'NONE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        InReview: 'IN_REVIEW' as StatusEnum,
        Done: 'DONE' as StatusEnum,
        Sent: 'SENT' as StatusEnum,
        None: 'NONE' as StatusEnum
    };
}


